import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
    render() {
        let export_name = "denuncias-abinetales-" + (new Date().getDay() < 10 ? "0" + new Date().getDay() : new Date().getDay()) + "-" + (new Date().getMonth() < 10 ? "0" + new Date().getMonth() : new Date().getMonth()) + "-" + new Date().getFullYear() + ".xlsx";
        return (
            <ExcelFile filename={export_name} element={<button className="btn btn-success react-bs-table-csv-btn  hidden-print"><i className='fas'>&#xf358;</i> Descargar</button>}>
                <ExcelSheet data={this.props.datos} name="Certificaciones">
                    <ExcelColumn label="Item" value="item" />
                    <ExcelColumn label="CÓDIGO" value="codigo" />
                    <ExcelColumn label="DEPARTAMENTO" value="departamento" />
                    <ExcelColumn label="PROVINCIA" value="provincia" />
                    <ExcelColumn label="DISTRITO" value="distrito" />
                    <ExcelColumn label="FECHA" value="fecha_registro" style={{numFmt: "m/dd/yy"}} />
                    <ExcelColumn label="SECTOR" value="sector" />
                    <ExcelColumn label="ESTADO" value="estado" />
                </ExcelSheet>
            </ExcelFile>
        );
    }
}

export default Download;